import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderWidth } from "../../../design-system/tokens/borders";
import { rawColors } from "../../../design-system/tokens/colors";

export {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
} from "../KgInspectorTablesTab/KgInspectorTablesTab.styles";

export { LinkRowStack } from "../KgInspectorMetricsTab/KgInspectorMetricsTab.styles";

export const TabRoot = styled.div`
  display: flex;
  flex-direction: column;
`;

export const EmptyTabBody = styled.div`
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
`;

export const RuleSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
  padding: ${spacing[4]} ${spacing[3]} ${spacing[3]};
  border-bottom: ${borderWidth[1]} solid ${rawColors.stroke[200]};
`;
